import Icon from '@mui/icons-material/ExpandMore';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function ExpandMoreIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
